export default class InvalidMasterSnapshotError extends Error {}
